import * as XLSX from 'xlsx';
import type { SurveyExportData } from '@/api/types';

export function exportToExcel<T extends Record<string, unknown>>(data: T[], filename: string, sheetName = 'Sheet1') {
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, `${filename}.xlsx`);
}

export function exportSurveyToExcel(data: SurveyExportData, filename: string) {
  const wb = XLSX.utils.book_new();

  // Sheet 1: General info
  const generalRows = [
    { Field: 'Name', Value: data.generalInfo.name },
    { Field: 'Description', Value: data.generalInfo.description ?? '' },
    { Field: 'Type', Value: data.generalInfo.type },
    { Field: 'Status', Value: data.generalInfo.status },
    { Field: 'Audience OUs', Value: data.generalInfo.ouIds.join(', ') },
    { Field: 'Response Count', Value: data.generalInfo.responseCount },
    { Field: 'Response Rate (%)', Value: data.generalInfo.responseRate },
    { Field: 'Expires At', Value: data.generalInfo.expiresAt ?? '' },
    { Field: 'Is Approved', Value: data.generalInfo.isApproved ? 'Yes' : 'No' },
    { Field: 'Created By', Value: data.generalInfo.createdBy },
    { Field: 'Created At', Value: data.generalInfo.createdAt },
  ];
  const ws1 = XLSX.utils.json_to_sheet(generalRows);
  XLSX.utils.book_append_sheet(wb, ws1, 'General');

  // Sheet 2: Questions
  const questionRows = data.questions.map(q => ({
    '#': q.order,
    Text: q.text,
    Type: q.type,
    Fundamental: q.fundamentalId ?? '',
    'Daily Habit': q.dailyHabitId ?? '',
  }));
  const ws2 = XLSX.utils.json_to_sheet(questionRows);
  XLSX.utils.book_append_sheet(wb, ws2, 'Questions');

  // Sheet 3: Feedbacks
  const feedbackRows = data.feedbacks.map(f => ({
    'Evaluator ID': f.evaluatorId,
    'Evaluated Name': f.evaluatedDisplayName ?? '',
    'Response Date': f.respondedAt,
    Question: f.questionText,
    Answer: f.answer,
  }));
  const ws3 = XLSX.utils.json_to_sheet(feedbackRows);
  XLSX.utils.book_append_sheet(wb, ws3, 'Feedbacks');

  XLSX.writeFile(wb, `${filename}.xlsx`);
}
